// Schedule preferences management for localStorage

export interface SchedulePreferences {
  view: "month" | "week" | "day" | "threeday" | "workweek";
  columnMode: "practitioner" | "day" | "services" | "room" | "day-practitioner";
  displayMode: "calendar" | "list";
  selectedServiceTypes: string[];
  selectedPharmacists: string[];
  selectedRooms: string[];
  selectedBlockOutTypes: string[];
}

const STORAGE_KEY = "schedule_preferences";

export function saveSchedulePreferences(preferences: SchedulePreferences): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(preferences));
  } catch (error) {
    console.error("Failed to save schedule preferences:", error);
  }
}

export function loadSchedulePreferences(): SchedulePreferences | null {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      return JSON.parse(stored);
    }
  } catch (error) {
    console.error("Failed to load schedule preferences:", error);
  }
  return null;
}

export function clearSchedulePreferences(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.error("Failed to clear schedule preferences:", error);
  }
}

export function hasSchedulePreferences(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) !== null;
  } catch (error) {
    return false;
  }
}
